"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = matchWindow;

var _Breakpoints = require("./Breakpoints");

function matchWindow(args
/* : {min, max} */
) {
  var queryString = (0, _Breakpoints.toMediaQuery)(args);
  var mq = typeof window !== 'undefined' ? window.matchMedia(queryString) : undefined;
  return !!(mq && mq.matches);
}